import { ErreurApi } from '../../api/client.js';

const MESSAGE_GENERIQUE = 'Une erreur est survenue de notre côté. Réessayez dans un instant ; si elle persiste, contactez le Cabinet MAAT.';

/** Phrase française destinée à Brigitte pour une erreur quelconque (jamais le détail du serveur, qui peut nommer le mandant). */
export const messageErreur = (e: unknown): string => (e instanceof ErreurApi ? e.messageUtilisateur : MESSAGE_GENERIQUE);
